import { render } from "./CategorySegmentView.vue?vue&type=template&id=c3cf2b9a&scoped=true"
import script from "./CategorySegmentView.vue?vue&type=script&lang=js"
export * from "./CategorySegmentView.vue?vue&type=script&lang=js"

import "./CategorySegmentView.vue?vue&type=style&index=0&id=c3cf2b9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3cf2b9a"]])

export default __exports__